import React from 'react';

const TooltipBox = ({ text = '', title = '', description = '' }) => {
  return (
    <div className="inline-block bg-white rounded-lg px-5 py-4 relative z-50 shadow-lg border border-gray-100 max-w-[280px]">
      {title && (
        <div className="text-black text-sm font-semibold font-['Inter'] leading-tight mb-1">
          {title}
        </div>
      )}
      <div className="text-black text-sm font-normal font-['Inter'] leading-tight">
        {description || text}
      </div>
    </div>
  );
};

export default TooltipBox;
